export default "__VITE_ASSET__DSryOhGp__"